import { MenuItemIcon } from "./MenuItemIcon";
export default MenuItemIcon;
